
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Switch from "@material-ui/core/Switch";
import { parseDate } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import CorrespondenceAddress from "./CorrespondenceAddress";
import { saveLoanDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import { Button, Grid, InputLabel, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import brandTheme from "brandTheme/Theme.js";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import ToastModal from "views/components/ToastModal";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
import { isValidPincode } from "assets/properties/properties";
import { sortByString } from "utils/Utils";
import { parseAndSetFlag } from "utils/Utils";
import { PreFixNameList } from "assets/properties/properties";
import { CHECK_LOAN_MARKINGS } from "assets/properties/properties";
import { textFormat } from "utils/Utils";
import { documentNamesList } from "assets/properties/properties";
import { loanApplicationStatus } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import { OccupationListData } from "assets/properties/properties";
import { purposeOfLoanListData } from "assets/properties/properties";
import { GenderListData } from "assets/properties/properties";
import { panAmountValidate } from "utils/Utils";
import { customerTypeData } from "assets/properties/properties";
import checkNegativeProfileApi from "./CheckNegativeProfileApi";
import ConfirmationModal from "views/components/ConfirmationModal";
import { minAge } from "assets/properties/properties";
import { maxAge } from "assets/properties/properties";
const styles = () => ({
  validateButton: {
    position: "absolute",
    top: 0,
    right: 0,
    padding: "11px 15px",
    margin: 0,
  },
  addressContainer: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    margin: "2% 0 0 1%",
    "@media (max-width:520px)": {
      flexDirection: "column",
      marginTop: "20px",
    },
  },
  nextButton: { backgroundColor: brandTheme.buttonColor },
});
const ApplicantPostAndRePledge = ({
  setBack,
  classes,
  setNext,
  loanApplicationId,
  loanApplicationNumber,
  status,
  previouseLoanAccountId,
  PanNameObj, PanNumberObj,
  editable,
  loanAccountNumber,
  loanType,
  mobileNum,
  panThirdPartyPanEnabled,
  featureFlags,
  firstTab,
  existingLoanData,
  subStatus,
  enabledFieldsForApplciantPage,
  actualLoanAmountForProcessingFee,
}) => {
  const dispatch = useDispatch();
  const { aadharDetails, aadharTranaction } = useSelector(
    (state) => state.loanApplication
  );
  const [panNumberDisabled, setPanNumberDIsabled]=useState(false)
  const { applicantDetails } = useSelector(
    (state) => state.loanDetail.applicantLoanDetail
  );
  const [documentNameList,setDocumentNameList]=useState([]);
  const [maritalStatusList]=useState([
    { code: "Single", name: "Single" },
    { code: "Married", name: "Married" },
  ]);
  const [maritalStatus, setMateritalStatus] = useState(
    applicantDetails?.maritalStatus ? applicantDetails?.maritalStatus : ""
  );
  const [maritalStatusState, setmaritalStatusState] = useState(false);
  const [motherName, setMotherName] = useState(
    applicantDetails?.motherName
  );
  const [motherNameErrorState, setMotherNameErrorState] = useState(false);
  const [spouseName, setSpouseName] = useState(
    applicantDetails?.spouseName
  );
  const [spouseNameState, setSpouseNameState] = useState(false);
  const [memberCount, setMemberCount] = useState(applicantDetails?.memberCount)
  const [memeberCountError, setMemberCountError] = useState(false);
  const [annualIncomeState, setAnnualIncomeState] = useState(false);
  const [annualIncome, setAnnualIncome] = useState(applicantDetails?.applicantAnnualIncome || "0")
  const [dateOfBirth, setDateOfBirth] = useState(applicantDetails?.dob);
  const [dateOfBirthState, setDateOfBirthState] = useState("");
  const [isAadharAvailable, setIsAadharAvailable] = useState(true);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadharNumber, setAadharNumber] = useState(
    applicantDetails?.adhaarNumber
  );
  const [aadharNumberState, setAadharNumberState] = useState(false);
  const [disableNext, setDisableNext] = useState(false);
  const [tsTransID, setTsTransID] = useState("");
  const [aadharApplicantName, setAadharApplicantName] = useState(
    applicantDetails?.nameOnAdhaar
  );
  const [aadharApplicantNameState, setAadharApplicantNameState] =
    useState(false);
  const [aadharFatherName, setAadharFatherName] = useState(
    applicantDetails?.fatherName
  );
  const [aadharFatherNameState, setAadharFatherNameState] = useState(false);
  const [email, setEmail] = useState(applicantDetails?.email);
  const [emailState, setEmailState] = useState(false);
  const [documentName, setDocumentName] = useState(
    applicantDetails?.documentName ? applicantDetails?.documentName : ""
  );
  const [documentNameState, setDocumentNameState] = useState(false);
  const [documentNumber, setDocumentNumber] = useState(
    applicantDetails?.documentNumber
  );
  const [documentNumberState, setDocumentNumberState] = useState(false);
  const [houseNumber, setHouseNumber] = useState(
    applicantDetails?.addresses?.[0]?.houseNumber
  );
  const [houseNumberState, setHouseNumberState] = useState(false);
  const [street, setStreet] = useState(
    applicantDetails?.addresses?.[0]?.street
  );
  const [streetState, setStreetState] = useState(false);
  const [locality, setLocality] = useState(
    applicantDetails?.addresses?.[0]?.locality
  );
  const [localityState, setLocalityState] = useState(false);
  const [postOffice, setPostOffice] = useState(
    applicantDetails?.addresses?.[0]?.postOffice
  );
  const [postOfficeState, setPostOfficeState] = useState(false);
  const [villageTownCity, setVillageTownCity] = useState(
    applicantDetails?.addresses?.[0]?.villageTownCity
  );
  const [villageTownCityState, setVillageTownCityState] = useState(false);
  const [stateName, setStateName] = useState(
    applicantDetails?.addresses?.[0]?.state
  );;
  const [district, setDistrict] = useState(
    applicantDetails?.addresses?.[0]?.district
  );
  const [districtState, setDistrictState] = useState(false);
  const [pincode, setPincode] = useState(
    applicantDetails?.addresses?.[0]?.pincode
  );
  const [pincodeState, setPincodeState] = useState(false);
  const [mobileNumber, setMobileNumber] = useState(
    applicantDetails?.alternateMobileNumber?.trim()
  );
  const [processingFee, setProcessingFee] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');;
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [emailVerify, setEmailVerify] = useState("");
  const [sameAddress, setSameAddress] = useState(applicantDetails?.sameAddress);
  const correspondancAddress = applicantDetails?.addresses?.[1];
  const [houseCorrNumberState, setHouseCorrNumberState] = useState(false);
  const [streetCorrState, setStreetCorrState] = useState(false);
  const [localityCorrState, setLocalityCorrState] = useState(false);
  const [postOfficeCorrState, setPostOfficeCorrState] = useState(false);
  const [prefixName, setPreFixName] = useState("")
  const [villageTownCityCorrState, setVillageTownCityCorrState] =
    useState(false);
  const [stateNameCorrState, setStateNameCorrState] = useState(false);
  const [districtCorrState, setDistrictCorrState] = useState(false);
  const [pincodeCorrState, setPincodeCorrState] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [gstNumberErrorMsg, setGstNumberErrorMsg] = useState("");
  const [gstNumber, setGstNumber] = useState(applicantDetails?.gstNumber);
  const [gst, setGst] = useState(applicantDetails?.gstState);
  const [documentDisbale, setDocumentDisable] = useState(false);
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const handleDateChange = (date) => {
    setDateOfBirth(date);
  };
  const handleDocumentExpiry=(date)=>{
    setDocumentExpiry(date)
    setDocumentExpiryState(false)
  }
  const [coresHouseNumber, setCoresHouseNumber] = useState(
    correspondancAddress?.houseNumber
  );
  const [coresStreet, setCoresStreet] = useState(correspondancAddress?.street);
  const [coresLocality, setCoresLocality] = useState(
    correspondancAddress?.locality
  );
  const [coresPostOffice, setCoresPostOffice] = useState(
    correspondancAddress?.postOffice
  );
  const [coresVillage, setCoresVillage] = useState(
    correspondancAddress?.villageTownCity
  );
  const [coresDistrict, setCoresDistrict] = useState(
    correspondancAddress?.district
  );
  const [coresPinCode, setCoresPinCode] = useState(
    correspondancAddress?.pincode
  );
  const [coresState, setCoresState] = useState(correspondancAddress?.state);
  const [gender, setGender] = useState(applicantDetails?.gender);
  const [purposeOfLoan, setPurposeOfLoan] = useState("");
  const [occupationTypes, setoccupationTypes] = useState("");
  const [digilance, setDigilance] = useState(false)
  const [digilanceData, setDigilanceData] = useState([])
  const [dueDigilance, setDueDigilance]= useState(false)
  const [digilanceState, setDigilanceState]= useState("")
  const [documentExpiryState, setDocumentExpiryState] = useState(false);
  const [documentExpiry, setDocumentExpiry]= useState(applicantDetails?.documentExpiry);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [riskPresent,setRiskPresent] = useState(false);
  const [stateNameState, setStateNameState] = useState(false);
  const outletData = featureFlags;
  const GenderList = outletData?.genderList ? JSON.parse(outletData?.genderList) : GenderListData;
  const validateThirdPartyAttemptsFlag = parseAndSetFlag(outletData?.validateThirdPartyAttemptsFlag);
    const enableNegativeProfileCheck = parseAndSetFlag(outletData?.enableCheckNegativeProfile);
  const enabledReKycForDocumentVerification = parseAndSetFlag(outletData?.enabledReKycForDocumentVerification);
  const showPreFixName = parseAndSetFlag(outletData?.showApplicantPreFixName);
  const annualIncomeAmount = outletData?.annualIncomeFlag;
  const showProcessingFeeApplicantFlag = parseAndSetFlag(outletData?.showProcessingFeeApplicantFlag);
  const checkForUnacceptableItemFlag = parseAndSetFlag(outletData?.checkForUnacceptableItemFlag);
  const showEmailOnApplicantFlag = parseAndSetFlag(outletData?.showEmailOnApplicantFlag);
  const checkForRestrictionFlag = parseAndSetFlag(outletData?.checkForRestrictionFlag);
  const disbaledAddharFlag = parseAndSetFlag(outletData?.hideSwitchForAadharApplicantPageFlag);
  const showCustomerType = parseAndSetFlag(outletData?.showCustomerType);
  const PurposeOfLoan = outletData?.purposeOfLoanFlag ? JSON.parse(outletData?.purposeOfLoanFlag) : purposeOfLoanListData;
  const OccupationList = outletData?.occupationListFlag ? JSON.parse(outletData?.occupationListFlag) : OccupationListData;
  const sameDayLoanProcessingFees = parseAndSetFlag(outletData?.sameDayLoanProcessingFees);
  const maxAgeForDateOfBirth = Number(outletData?.maxAgeForDateOfBirth) || maxAge;
  const minAgeForDateOfBirth = Number(outletData?.minAgeForDateOfBirth) || minAge;

  const [prefixNameState, setPreFixNameState] = useState(false)
  const [panApplicantName, setPanApplicantName] = useState("");
  const [panApplicantNumber, setPanApplicantNumber]= useState("");
  const [panApplicantNumberState, setPanApplicantNumberState] = useState(false);
  const [totalAmountPerYear, setTotalLoanAmountPerYear]=useState(0);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [panVerified, setPanVerified] = useState(false);
  const [panVerifiedName, setPanVerifiedName] = useState(true);
  const enabledPanVerifiedFlag = parseAndSetFlag(outletData.enabledPanVerifiedFlag);
  const PANCRITERIA = Number(outletData?.panThreshHoldFlag);
  const YEARLYPANCRITERIA = Number(outletData?.panThreshHoldYearlyFlag);
  const checkActualLoanAmountPerYear = parseAndSetFlag(outletData.checkTotalLoanAmountInYear);
  const iflActualLoanAmount = Number(totalAmountPerYear) + Number(actualLoanAmount);
  const [customerId, setCustomerId] = useState("")
  const [panValidate,setPanValidated]=useState(true);
  const [customerType, setCustomerType]=useState(customerTypeData?.[0]?.code);
     const [negativePresent,setNegativePresent] = useState(false);
  const [emailValidationAttempted, setEmailValidationAttempted] = useState({
        success:false,
        error:false,
      });
      const [panValidationAttempted, setPanValidationAttempted] = useState({
        success:false,
        error:false,
      });
      const [aadharValidationAttempted, setAadharValidationAttempted] = useState({
        success:false,
        error:false,
      });
  const adharNumberSplit =
    aadharTranaction.aadharNumber?.slice(-4) ===
    aadharDetails?.adhaarNumber?.slice(-4);
    useEffect(()=>{
      if(showProcessingFeeApplicantFlag){
      getLoanProcessingFee();}
    },[showProcessingFeeApplicantFlag])
    const getLoanProcessingFee = async () =>{
       const requestOptions = {
        url: endpoint.DISBURSAL_SCHEME_CHARGES + loanApplicationId,
        authToken: authToken,
        method:"POST"
      };
      requestOptions.data = {};
      if (sameDayLoanProcessingFees && Number(actualLoanAmountForProcessingFee) > 0) {
        requestOptions.data.loanAmountForProcessFee = actualLoanAmountForProcessingFee;
      }
      const result = await apiHandler(requestOptions);
      if(result?.data?.error_code){
        toastUpdate("Error", result?.data?.user_description, true);
  
      }else {
        result?.data?.schemeCalculations?.forEach((item) =>{ if(item.chargeType==="PROCESSING_FEE"){setProcessingFee(item?.adjustedAmount)}})
      }
    }
    useEffect(()=>{
      getAllDocumentNames();
    },[])
    const getAllDocumentNames = async () =>{
      const result = await apiHandler({
        url: endpoint.GET_ALL_DOCUMENT_NAMES,
        authToken: authToken,
      });
      if(result?.data?.error_code){
        toastUpdate("Error", result?.data?.user_description, true);
      }else {
        setDocumentNameList(result?.data);
      }
    }
    const GetStateData = async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.MASTER_STATE_FINDALL,
        authToken: authToken,
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        const sortedData = sortByString(result?.data,'name',true);
        setStateList(sortedData);
      }
    };
  useEffect(() => {
    if (
      adharNumberSplit &&
      aadharDetails?.adhaarNumber &&
      aadharNumber &&
      isAadharAvailable
    ) {
      toastUpdate("Information", "Aadhar number is matched", true);

    }
    if (
      !adharNumberSplit &&
      aadharDetails?.adhaarNumber &&
      aadharNumber &&
      isAadharAvailable
    ) {
      toastUpdate("Warning", "Aadhar not matched", true);

    }
  }, [
    aadharDetails && typeof aadharDetails?.adhaarNumber !== "undefined",
    aadharNumber,
  ]);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

  };

  useEffect(() => {
    if(!firstTab && editable){
    updateRecords(status);
    }
  }, [status, editable, firstTab]);

  useEffect(() => {
    GetApplicantDetails();
    if(status === "INPROCESS"){
      getDigilanceData()
      }
    if (dateOfBirth === "undefined") {
      setDateOfBirth("");
    }
  }, []);

  useEffect(() => {
    if ((!documentNumber || !email) && status === "INPROCESS" ) {
      getLoanDetails();
    }
  }, [!documentNumber]);

  const updateRecords = async () => {
    await GetLoanOrnamentDetails();
  };

  const GetApplicantDataFromLms = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code) {
      const customerIds = res?.data?.map((customer) => customer?.customerId);
      const customerIdsString = customerIds?.join(", ");
      const errorMessage = `Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`;
      if (res?.data?.length > 1) {
        toastUpdate("Error", errorMessage, true);
        setDisableNext(true);
      } else if (res?.data?.length === 1) {
        setCustomerId(res?.data?.[0]?.customerId)
        if (mobileNum?.trim() === res?.data?.[0]?.communication?.primarymobileNumber?.trim()) {
          setDisableNext(false);
          if(enableNegativeProfileCheck){
          const apiReponse = await checkNegativeProfileApi(apiHandler,
              endpoint,
              authToken,
              setCallInProgress,
              toastUpdate,
              res?.data?.[0]?.adharNumber,
              res?.data?.[0]?.panNumber,)
               if (apiReponse?.[0]?.risk) {
                setNegativePresent(apiReponse?.[0]?.risk);
                proceedApplication();
              }
            }
          updateData(res?.data?.[0], 'search')
        }
      } else {
        setDisableNext(false);
      }
    } else {
      setDisableNext(false);
    }
  };

  const GetApplicantDetails = async () => {
    setCallInProgress(true);
    const loanAccountNumber = loanApplicationId;
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanAccountNumber,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data === "") {
      if (!existingLoanData?.applicantDetailResponse?.name) {
          await GetApplicantDataFromLms()
        } else {
          updateData(existingLoanData?.applicantDetailResponse,'oldData');
        }
    }else{
      updateData(result?.data)
    }
  };

  const updateData=(result, type)=>{
    setIsAadharAvailable(result?.adhaarAvailable);
    let addressData = result?.addresses;
    let permanentAddress = result?.addresses;
    let identification = []
    if(type === 'oldData'){
      addressData = result?.customerAddress;
      permanentAddress= result?.customerAddress;
      identification = result?.identificationDetails;
    }else if (type === 'search'){
      addressData=result?.address,
      permanentAddress= result?.address?.[0]?.fullAddress;
      identification = result?.identification
    }
  const panArray= type ? identification?.filter((item)=> item?.identificationType?.toLowerCase() === 'pan') : "";
    const documentArray = type  ? identification?.filter((item)=> item?.identificationType?.toUpperCase() !== 'PAN') : '';
    const name = (type === "search" || type === "oldData") ? documentArray?.[0]?.documentName?.toLowerCase() : result?.documentName?.toLowerCase();
    let apiDocumentName = "";
    if (
      name === "adhaar card" ||
      name === "aadhar card" ||
      name === "aadhar_card" ||
      name === "adhar_card"
    ) {
      apiDocumentName = "AADHAR_CARD";
    } else if (
      name === "voter id" ||
      name === "voter_id" ||
      name === "VOTER_ID" ||
      name === "VOTER ID"
    ) {
      apiDocumentName = "VOTER_ID"
    } else if (name === "passport") {
      apiDocumentName = "PASSPORT" 
    } else if(name === "other"){
      apiDocumentName = "OTHER"
    } else{
      apiDocumentName=type === "search" ? documentArray?.[0]?.documentName : result?.documentName
    }
    if(result?.adhaarAvailable){
        setAadharValidationAttempted({success:true});
      }
      const panVerified = panArray?.[0]?.verified ?? result?.panVerified;
      if (result?.panNumber) {
        if (panVerified) {
          setPanValidationAttempted({ success: true });
        } else {
          setPanValidationAttempted({ error: true });
        }
      }
       setNegativePresent(result?.customerRisk);
      if(type){
      if (apiDocumentName === documentNamesList?.aadhaar) {
        setAadharNumber(documentArray?.[0]?.identificationNum)
        if (documentArray?.[0]?.verified) {
          setAadharValidationAttempted({ success: true });
          setIsAadharAvailable(true);
        } else {
          setAadharValidationAttempted({ error: true });
          setIsAadharAvailable(false);
        }
      }
    }else{
      if(!result?.adhaarAvailable && (result?.adhaarNumber || result?.documentNumber) && apiDocumentName === "AADHAR_CARD"){
          setAadharValidationAttempted({error:true});
          setIsAadharAvailable(false);
        }
        if(result?.adhaarAvailable && (result?.adhaarNumber || result?.documentNumber) && apiDocumentName === "AADHAR_CARD"){
          setAadharValidationAttempted({success:true});
          setIsAadharAvailable(true);
      }
    }
    if(result?.email){
        setEmailValidationAttempted({success:true});
    }
    setAadharNumber(result?.adhaarNumber?.trim() || result?.adharNumber?.trim());
    setDocumentName(apiDocumentName);
    setPanApplicantName(result?.nameOnPanCard || PanNameObj)
    setPanNumberDIsabled(result?.panNumber || PanNumberObj)
    setPanApplicantNumber(result?.panNumber || PanNumberObj);
    if((result?.panNumber  || PanNumberObj) && (result?.nameOnPanCard  || PanNameObj)){
        setPanVerified(true);
    }
    setDocumentNumber(result?.documentNumber?.trim() || result?.adharNumber?.trim() || result?.adhaarNumber?.trim());
    setAadharApplicantName(type === "search" ? textFormat(result?.applicantName) : result?.nameOnAdhaar);
    setAadharFatherName(result?.fatherName);
    setDateOfBirth(type === "search"  ? result?.dateOfBirth : result?.dob);
    setEmail(result?.email);
    setMobileNumber(type === "search" ? result?.communication?.alternateMobileNumber?.trim() : result?.alternateMobileNumber?.trim());
    setGstNumber(result?.gstNumber);
    setGst(result?.gstState);
    setSameAddress(result?.sameAddress);
      GetStateData();
    setHouseNumber(permanentAddress[0]?.houseNumber || permanentAddress[0]?.houseNo);
    setStreet(permanentAddress[0]?.street );
    setLocality(permanentAddress[0]?.locality );
    setPincode(permanentAddress[0]?.pincode);
    setPostOffice(permanentAddress[0]?.postOffice );
    setDistrict(permanentAddress[0]?.district );
    setVillageTownCity(permanentAddress[0]?.villageTownCity || permanentAddress?.[0]?.villageTownCity );
    setStateName(permanentAddress[0]?.state);
    setCustomerType(result?.customerType)
    if(result?.occupationType){
      if(OccupationList?.includes(result?.occupationType)){
        setoccupationTypes(result?.occupationType)
      }else{
        setoccupationTypes(OccupationList?.[0])
      }
    }
    if(result?.purposeOfLoan){
        if(PurposeOfLoan?.includes(result?.purposeOfLoan)){
          setPurposeOfLoan(result?.purposeOfLoan)
        }else{
          setPurposeOfLoan(PurposeOfLoan?.[0])
        }
     }
    setGender(result?.gender || 'Male');
    setMotherName((result && result?.motherName) || "");
    setPreFixName(result?.applicantNamePrefix || "Mr")
    setMateritalStatus((result && result?.maritalStatus) || "");
    if(result?.dueDiligence){
      setDigilance(true)
      setDigilanceState(result?.dueDiligence || "")
    }
    setAnnualIncome((result && result?.applicantAnnualIncome) || "0");
    setMemberCount((result && result?.memberCount) || "");
    setDocumentExpiry(type ? documentArray?.[0]?.documentExpiry : result?.documentExpiry || "")
    setSpouseName((result && result?.spouseName) || "");
    const correspondingData=addressData?.filter((item) => item.addressType === "RESIDENTIAL_ADDRESS" || item?.addressType==="CORRESPONDENCE_ADDRESS");
    setCoresHouseNumber(type === "search"  ? correspondingData?.[0]?.fullAddress?.houseNo :correspondingData[0]?.houseNumber ?? correspondingData?.[0]?.houseNo);
    setCoresDistrict(type === "search"  ? correspondingData?.[0]?.fullAddress?.district :correspondingData[0]?.district);
    setCoresLocality(type === "search"  ? correspondingData?.[0]?.fullAddress?.locality :correspondingData[0]?.locality);
    setCoresPinCode(type === "search"  ? correspondingData?.[0]?.fullAddress?.pincode :correspondingData[0]?.pincode);
    setCoresPostOffice(type === "search"  ? correspondingData?.[0]?.fullAddress?.postOffice :correspondingData[0]?.postOffice);
    setCoresState(type === "search"  ? correspondingData?.[0]?.fullAddress?.state :correspondingData[0]?.state);
    setCoresStreet(type === "search"  ? correspondingData?.[0]?.fullAddress?.street :correspondingData[0]?.street);
    setCoresVillage(type === "search" ? correspondingData?.[0]?.fullAddress?.city :correspondingData[0]?.villageTownCity);
  }
  const getDigilanceData = async () => {
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.FIND_DIGILLANCE,
      authToken: authToken,
    });
    if(result?.data){
   setDigilanceData(result?.data)
  }
  };
  const GetLoanOrnamentDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
 if (result?.data?.error_code) {
  toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setActualLoanAmount(result?.data?.actualLoanAmount)
      dispatch(
        saveLoanDetails({
          ornamentDetail: result.data,
        })
      );
    }
  };
  useEffect(()=>{
    if(status === "INPROCESS" && customerId && checkActualLoanAmountPerYear){
      getTotalLoanAmount()
    }
  },[customerId])

  const getTotalLoanAmount = async () => {
    const result = await apiHandler({
      url: endpoint.TOTAL_LOAN_IN_YEAR + customerId + "/total-loan",
      authToken: authToken,
    });
    if (!result?.data?.error_code) {
      setTotalLoanAmountPerYear(result?.data?.totalLoanTaken)
  }
};
const DocumentStatusHelper = async (value, verified) => {
  const result = await apiHandler({
    url: endpoint.CHECK_PROFILE_RESTRICTION + value?.[0]?.customerId,
    authToken: authToken,
  });
  const statusArray = result?.data?.markingActions;
  const deathOrLegalAccounts = result?.data?.restrictions
  .filter(entry => {
  const loanMarkingAction = entry?.loanMarkingAction || "";
  const loanAuditActions = entry?.loanAuditActions || [];
        const hasSpuriousGold =
          loanAuditActions?.some(
            action =>
              action === `[${CHECK_LOAN_MARKINGS.spuriousGold}]` ||
              action === CHECK_LOAN_MARKINGS.spuriousGold
          );
        
        const hasUnacceptableItem =
          checkForUnacceptableItemFlag &&
          loanAuditActions?.some(
            action =>
              action === `[${CHECK_LOAN_MARKINGS.unacceptableItem}]` ||
              action === CHECK_LOAN_MARKINGS.unacceptableItem
          );
  return (
      loanMarkingAction.includes(CHECK_LOAN_MARKINGS.death) ||
      loanMarkingAction.includes(CHECK_LOAN_MARKINGS.legal) ||
      (entry?.npa === true && entry?.status !== "CLOSED") ||
      (hasSpuriousGold && entry?.status !== "CLOSED") ||
      (hasUnacceptableItem && entry?.status !== "CLOSED") ||
      (entry?.dueDiligence && entry?.dueDiligence.trim() !== '')
  );
});
const filteredCases = deathOrLegalAccounts.filter(loan => {
const loanAuditActions = loan?.loanAuditActions || [];
    const hasSpuriousGold =
      loanAuditActions.includes(CHECK_LOAN_MARKINGS.spuriousGold);
    const hasUnacceptableItem =
      checkForUnacceptableItemFlag &&
      loanAuditActions.includes(CHECK_LOAN_MARKINGS.unacceptableItem);
return (
    (loan?.status !== "CLOSED" &&
      (hasSpuriousGold || hasUnacceptableItem)) ||
    loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death ||
    loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal ||
    (loan?.npa === true && loan?.status !== "CLOSED") ||
    (loan?.dueDiligence && loan?.dueDiligence.trim() !== '')
);
});

const formatAction = (action) => {
  switch (action) {
      case CHECK_LOAN_MARKINGS.spuriousGold:
          return 'SPURIOUS GOLD';
        case CHECK_LOAN_MARKINGS.unacceptableItem:
        return 'UNACCEPTABLE ITEM';
      default:
          return action;
  }
};
const groupedMessages = filteredCases?.reduce((acc, loan) => {
  const formattedAuditActions = loan?.loanAuditActions
      ?.filter(action => action === CHECK_LOAN_MARKINGS.spuriousGold ||
        (checkForUnacceptableItemFlag && action === CHECK_LOAN_MARKINGS.unacceptableItem))
      ?.map(formatAction)
      ?.join(', ');

  const formattedMarkingAction = (loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.death || loan?.loanMarkingAction === CHECK_LOAN_MARKINGS.legal) ?
      loan.loanMarkingAction : '';

  const npaStatus = loan?.npa ? 'NPA' : '';
  const dueDiligence = loan?.dueDiligence ? `Due Diligence: ${loan.dueDiligence}` : '';

  const messageParts = [];
  if (formattedAuditActions) messageParts.push(formattedAuditActions);
  if (formattedMarkingAction) messageParts.push(formattedMarkingAction);
  if (npaStatus) messageParts.push(npaStatus);
  if (dueDiligence) messageParts.push(dueDiligence);

  const messageContent = messageParts.join(' and ');

  const message = `For this customer, against ${loan.loanAccountNumber} loan status is ${messageContent}.\n`;

  if (!acc.processedAccounts.has(loan.loanAccountNumber)) {
      if (acc.groupedMessages[loan.loanAccountNumber]) {
          acc.groupedMessages[loan.loanAccountNumber].push(message);
      } else {
          acc.groupedMessages[loan.loanAccountNumber] = [message];
      }
      acc.processedAccounts.add(loan.loanAccountNumber);
  }

  return acc;
}, { groupedMessages: {}, processedAccounts: new Set() });

const noticeMessages = Object.entries(groupedMessages.groupedMessages).map(([accountNumber, messages]) => {
  return messages.join('');
}).join('');

const joinLoanAccountNumber = Object.keys(groupedMessages.groupedMessages).join(', ');
  if (joinLoanAccountNumber  && (!checkForRestrictionFlag || (checkForRestrictionFlag && result?.data?.restriction))) {
    toastUpdate("Error",noticeMessages, true);
  } else {
    if (verified && panApplicantNumber) {
      verifyPAN();
    } else {
      setPanApplicantNumber(value?.[0]?.panNumber);
      setPanApplicantName(value?.[0]?.nameOnPanCard);
      setPanVerified(true);
    }
  }
};
  const getLoanDetails = async () => {
    // Get Loan Application Details
    const loanAccountNumber =  loanApplicationId;
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanAccountNumber,
      authToken: authToken,
    });
    if(result?.data?.email === ""){
      if(existingLoanData?.applicantDetailResponse?.email){
         setEmail(existingLoanData?.applicantDetailResponse?.email);
      }
    }else{
      setEmailValidationAttempted({success:true});
      setEmail(result?.data?.email);
    }
  };
  const GetProfileData = async (verified) => {
    setCallInProgress(true);
    const queryParams = !verified
      ? mobileNum
      : `${mobileNum?.trim()},${panApplicantNumber?.toUpperCase().trim()}`;
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + queryParams,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!res?.data?.error_code) {
      const customerIds = res?.data?.map((customer) => customer?.customerId);
      const customerIdsString = customerIds?.join(", ");
      const errorMessage = verified
        ? "Pan is Linked with other customer"
        : `Multiple Customer id ${customerIdsString} exists with same mobile number. Kindly correct the same before new loan creation.`;
      if (res?.data?.length > 1) {
        toastUpdate("Error", errorMessage, true);
      } else if (res?.data?.length === 1) {
        setCustomerId(res?.data?.[0]?.customerId)
        if (
          verified &&
          mobileNum?.trim() !== res?.data?.[0]?.communication?.primarymobileNumber?.trim()
        ) {
          toastUpdate("Error","Pan is Linked with other customer", true);
        }else if (
          verified &&
          mobileNum?.trim() === res?.data?.[0]?.communication?.primarymobileNumber?.trim()
        ) {
           if (verified && panApplicantNumber) {
            verifyPAN();
          } else {
            setPanApplicantNumber(res?.data?.[0]?.panNumber);
            setPanApplicantName(res?.data?.[0]?.nameOnPanCard);
            setPanVerified(true);
          }
        } 
      } else {
        if (verified) {
          verifyPAN();
        }
      }
    } else {
      if (verified && panApplicantNumber) {
        verifyPAN();
      }
    }
  };
  const verifyPAN = async () => {
    setCallInProgress(true);
    const response = await apiHandler({
      url: endpoint.NEW_PAN_CARD_VERIFY,
      authToken: authToken,
      method: "POST",
      data: {
        panNumber: panApplicantNumber?.toUpperCase(),
        dob:parseDate(dateOfBirth),
        name:aadharApplicantName
      },
    });
    setCallInProgress(false);
    if((response?.data?.error_code || response?.data?.name?.trim() === "" || !response?.data || response?.data?.name === null || !response) && !panThirdPartyPanEnabled){
      setPanVerified(true);
      setPanVerifiedName(false);
    }
    else if (response?.data?.error_code) {
      setPanApplicantNumber("");
      setPanApplicantNumberState(true);
      setPanVerified(false);
      setPanValidated(false);
      setPanVerifiedName(true);
      toastUpdate("Error", response?.data?.user_description, true)
      return;
    } else if (response?.data?.name?.trim() === "") {
      setPanVerified(false);
      setPanVerifiedName(true);
      setPanValidated(true);
    } else {
      setPanApplicantName(response?.data?.name);
      setPanApplicantNumber(response?.data?.panCard);
      setPanVerified(true);
      setPanVerifiedName(true);
      setPanValidated(true);
      setPanApplicantNumberState(false);
    }
  };
  const isValidated = () => {
    if(aadharApplicantName === "" || typeof aadharApplicantName === "undefined"){
      setAadharApplicantNameState(true);
    }else{
      setAadharApplicantNameState(false);
    }
    if (dateOfBirth === "" || typeof dateOfBirth === "undefined" || parseDate(dateOfBirth) === 'NaN-NaN-NaN') {
      setDateOfBirthState(true);
    } else {
      setDateOfBirthState(false);
    }  
    if(showPreFixName && ((prefixName === "Mr" && gender === "Female") || ((prefixName === "Mrs" || prefixName === "Miss") && gender === "Male"))){
      setPreFixNameState(true);
    }else{
      setPreFixNameState(false);
    }  
    if (panApplicantNumber?.length > 0 && panApplicantNumber?.length < 10) {
      setPanApplicantNumberState(true);
      return false;
    } else {
      setPanApplicantNumberState(false);
    }
    if (memberCount === "" || typeof memberCount === "undefined") {
      setMemberCountError(true);
    } else {
      setMemberCountError(false);
    }
    if (annualIncome === "" || typeof annualIncome === "undefined" || Number(annualIncome) < Number(annualIncomeAmount)) {
      setAnnualIncomeState(true);
    } else {
      setAnnualIncomeState(false);
    }
    if (maritalStatus === "" || typeof maritalStatus === "undefined") {
      setmaritalStatusState(true);
    } else {
      setmaritalStatusState(false);
    }
    if (maritalStatus === "Married" && (spouseName === "" || typeof spouseName === "undefined")) {
      setSpouseNameState(true);
      return false;
    } else {
      setSpouseNameState(false);
    }
    if (
      sameAddress
        ? houseNumber === ""
        : coresHouseNumber === "" || typeof coresHouseNumber === "undefined"
    ) {
      sameAddress ? setHouseNumberState(true) : setHouseCorrNumberState(true);
    } else {
      sameAddress ? setHouseNumberState(false) : setHouseCorrNumberState(false);
    }
    if (
      sameAddress
        ? street === ""
        : coresStreet === "" || typeof coresStreet === "undefined"
    ) {
      sameAddress ? setStreetState(true) : setStreetCorrState(true);
    } else {
      sameAddress ? setStreetState(false) : setStreetCorrState(false);
    }
    if (
      sameAddress
        ? locality === ""
        : coresLocality === "" || typeof coresLocality === "undefined"
    ) {
      sameAddress ? setLocalityState(true) : setLocalityCorrState(true);
    } else {
      sameAddress ? setLocalityState(false) : setLocalityCorrState(false);
    }
    if (
      sameAddress
        ? postOffice === ""
        : coresPostOffice === "" || typeof coresPostOffice === "undefined"
    ) {
      sameAddress ? setPostOfficeState(true) : setPostOfficeCorrState(true);
    } else {
      sameAddress ? setPostOfficeState(false) : setPostOfficeCorrState(false);
    }
    if (
      sameAddress
        ? villageTownCity === ""
        : coresVillage === "" || typeof coresVillage === "undefined"
    ) {
      sameAddress
        ? setVillageTownCityState(true)
        : setVillageTownCityCorrState(true);
    } else {
      sameAddress
        ? setVillageTownCityState(false)
        : setVillageTownCityCorrState(false);
    }
    if (
      sameAddress
        ? stateName === ""
        : coresState === "" || typeof coresState === "undefined"
    ) {
      sameAddress ? setStateNameState(true) : setStateNameCorrState(true);
    } else {
      sameAddress ? setStateNameState(false) : setStateNameCorrState(false);
    }
    if (
      sameAddress
        ? district === ""
        : coresDistrict === "" || typeof coresDistrict === "undefined"
    ) {
      sameAddress ? setDistrictState(true) : setDistrictCorrState(true);
    } else {
      sameAddress ? setDistrictState(false) : setDistrictCorrState(false);
    }
    if (
      sameAddress
        ? pincode === "" || !isValidPincode(pincode)
        : coresPinCode === "" || typeof coresPinCode === "undefined" || !isValidPincode(coresPinCode)
    ) {
      sameAddress ? setPincodeState(true) : setPincodeCorrState(true);
    } else {
      sameAddress ? setPincodeState(false) : setPincodeCorrState(false);
    }
    if (
      panApplicantNumber &&
      (panApplicantName?.trim().length === 0 ||
        typeof panApplicantName === "undefined" ||
        panApplicantName === null)
    ) {
      toastUpdate("Error", "Please Verify Pan", true);
      return false;
    }
    if (mobileNumber && mobileNumber.length !== 10) {
      setMobileNumberState(true);
    } else {
      setMobileNumberState(false);
    }
    if (digilance && (digilanceState === "" || typeof digilanceState === "undefined")){
      setDueDigilance(true);
      return false;
    }else{setDueDigilance(false)}
    if (
      aadharApplicantName &&
      aadharApplicantName !== "" &&
      memberCount &&
      memberCount !== "" &&
      annualIncome &&
      annualIncome !== "" &&
      Number(annualIncome) >= Number(annualIncomeAmount) &&
      maritalStatus &&
      maritalStatus !== "" &&
      dateOfBirth &&
      dateOfBirth !== "" &&
      parseDate(dateOfBirth) !== 'NaN-NaN-NaN' && 
      (sameAddress
        ? houseNumber &&
          houseNumber !== "" &&
          pincode &&
          isValidPincode(pincode) &&
          stateName &&
          stateName !== "" &&
          street &&
          street !== "" &&
          locality &&
          locality !== "" &&
          villageTownCity &&
          villageTownCity !== "" &&
          district &&
          district !== "" &&
          postOffice &&
          postOffice !== "" &&
          ((mobileNumber && mobileNumber.length === 10) || !mobileNumber)
        : coresHouseNumber &&
          coresHouseNumber !== "" &&
          coresStreet &&
          coresStreet !== "" &&
          coresDistrict &&
          coresDistrict !== "" &&
          coresVillage &&
          coresVillage !== "" &&
          coresLocality &&
          coresLocality !== "" &&
          coresPostOffice &&
          coresPostOffice !== "" &&
          coresPinCode &&
          isValidPincode(coresPinCode) &&
          coresState &&
          coresState !== "" &&
          houseNumber &&
          houseNumber !== "" &&
          pincode &&
          isValidPincode(pincode) &&
          street &&
          street !== "" &&
          locality &&
          locality !== "" &&
          villageTownCity &&
          villageTownCity !== "" &&
          district &&
          district !== "" &&
          postOffice &&
          postOffice !== "" &&
          stateName &&
          stateName !== "" 
         ) &&
         (!showPreFixName ||
          (showPreFixName &&
            ((prefixName === "Mr" && gender !== "Female") ||
              ((prefixName === "Mrs" || prefixName === "Miss") && gender !== "Male")))
        ) && ((mobileNumber && mobileNumber.length === 10) || !mobileNumber)
    ) {
      if (panAmountValidate(checkActualLoanAmountPerYear, actualLoanAmount,  PANCRITERIA, iflActualLoanAmount, YEARLYPANCRITERIA) && !firstTab) {
        if (
          panApplicantNumber !== "" &&
          typeof panApplicantNumber !== "undefined" &&
          panApplicantName !== "" &&
          typeof panApplicantName !== "undefined" &&
          panVerified === true
        ) {
          setPanApplicantNumberState(false);
          return true;
        } else {
          setPanApplicantNumberState(true);
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  const handlecreateapplicantSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    
  // if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
    const isValid = isValidated(); // Run the validation
    if (!isValid) {
      return; // If validation fails, return early and do not proceed
    }
  // }
      const res = await apiHandler({
        url: endpoint.ADMIN_APPLICANT_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          email: email && email !== "" ? email?.toLowerCase() : "",
          panNumber: panApplicantNumber && panApplicantNumber !== "" ? panApplicantNumber : null,
          nameOnPanCard:
            panApplicantName && panApplicantName !== "" ? panApplicantName : null,
          adhaarNumber:
            aadharNumber && aadharNumber !== "" ? aadharNumber?.trim() : null,
          nameOnAdhaar:
            aadharApplicantName && aadharApplicantName !== ""
              ? aadharApplicantName
              : panApplicantName,
          dob: parseDate(dateOfBirth),
          fatherName:
            aadharFatherName && aadharFatherName !== ""
              ? aadharFatherName
              : null,
              dueDiligence:digilanceState,
          addresses: [
            {
              addressType: "PERMANENT_ADDRESS",
              houseNumber:
                houseNumber && houseNumber !== "" ? houseNumber : null,
              street: street && street !== "" ? street : null,
              locality: locality && locality !== "" ? locality : null,
              postOffice: postOffice && postOffice !== "" ? postOffice : null,
              villageTownCity:
                villageTownCity && villageTownCity !== ""
                  ? villageTownCity
                  : null,
              state: stateName && stateName !== "" ? stateName : null,
              district: district && district !== "" ? district : null,
              pincode: pincode && pincode !== "" ? pincode : null,
            },
            {
              addressType: "RESIDENTIAL_ADDRESS",
              houseNumber: sameAddress ? houseNumber : coresHouseNumber,
              street: sameAddress ? street : coresStreet,
              locality: sameAddress ? locality : coresLocality,
              postOffice: sameAddress ? postOffice : coresPostOffice,
              villageTownCity: sameAddress ? villageTownCity : coresVillage,
              state: sameAddress ? stateName : coresState,
              district: sameAddress ? district : coresDistrict,
              pincode: sameAddress ? pincode : coresPinCode,
            },
          ],
          documentName:
            documentName && documentName !== "" ? documentName : null,
          documentNumber:
            documentNumber && documentNumber !== "" ? documentNumber?.trim() : null,
          alternateMobileNumber:
            mobileNumber && mobileNumber !== "" ? mobileNumber?.trim() : null,
          gender: gender || "Male",
          occupationType: occupationTypes || OccupationList?.[0],
          purposeOfLoan: purposeOfLoan || PurposeOfLoan?.[0],
          gstNumber: gstNumber || "",
          gstState: gst || "",
          sameAddress: sameAddress || false,
          adhaarAvailable: isAadharAvailable,
          spouseName: maritalStatus === "Single" ? "NA" : spouseName || "NA",
          maritalStatus: maritalStatus || '',
          memberCount: memberCount|| '',
          applicantAnnualIncome: annualIncome || '',
          motherName: motherName || '',
          applicantNamePrefix: prefixName || "Mr",
          documentExpiry: (documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") ? parseDate(documentExpiry) : '',
          panVerified:panVerified,
           customerRisk:negativePresent || false,
          ...(showCustomerType && {customerType:customerType})
        },
      });
      //this.setState({ -: false });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Create Applicant successfully", true);

        setNext();
      }
  };

  // cancel button function
  const handlecancelapplicant = () => {
    dispatch(saveAadharDetails(""));
    setBack();
  };

  const handlenext = () => {
    setNext();
  };

  const back = () => {
    setBack();
  };

  const setyear = (year) => {
    var date = new Date();
    date.setFullYear(date.getFullYear() - year);
    return date; //# => Thu Mar 31 2011 11:14:50 GMT+0200 (CEST)
  };

  const emaildataVerify = (e) => {
    setEmail(e);
    setEmailVerify("error");
  };
  const checkedDueDigilance =(e)=>{
    setDigilance(e.target.checked)
    if(e.target.checked === false){
      setDigilanceState("")
    }
  }
  const handleChange3 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMemberCount(e);
    }
  };
  const handleChange4 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setAnnualIncome(e);
    }
  };
  const setAnnualIcomeBlur = (e)=>{
    if(Number(e) < Number(annualIncomeAmount))
 toastUpdate("Error", `Annual Income should be equal or more than ${annualIncomeAmount}`, true)
  }
  const handleCorspinCode = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setCoresPinCode(e);
    }
  };
  const checkedAddress = (e) => {
    if (e.target.checked) {
      setSameAddress(true);
    } else {
      setSameAddress(false);
    }
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };
  const gstStateName = stateList?.filter((item)=> item?.code === gst);
  const handlePreFixName =(e)=>{
    setPreFixName(e);
    if(e === "Mr"){
      setGender("Male")
    }else{
      setGender("Female")
    }
  }
   const closeConfirmationModal = () => {
       setConfirmationModal(false);
       setConfirmationModalHeader("");
       setConfirmationModalMsg("");
     };
     
     const handleNegativeResponse = () => {
       closeConfirmationModal();
       setRiskPresent(true);
     };
     
     const handlePositiveResponse = () => {
       closeConfirmationModal();
       setRiskPresent(false);
     };
  const proceedApplication = () => {
    setConfirmationModalHeader("Risk Warning");
    setConfirmationModalMsg(
      "Customer is in negative list, Do you want to proceed"
    );
    setConfirmationModal(true);
  };
  return (
    <div>
      <Grid container >
        <Grid item xs={12} sm={12} md={12}>
               <SubHeader
                      label={headerLabel?.applicant}
                      subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                      onlyLabel/>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
        {showProcessingFeeApplicantFlag &&  <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Processing Fee(Inclusive of GST)"
              required
              value={processingFee || ""}
              disabled
              />
          </Grid>}
          {!disbaledAddharFlag &&
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <FormControlLabel
              control={
                <Switch
                  checked={isAadharAvailable}
                  name="checkedB"
                  color="primary"
                  disabled={true}
                />
              }
              label="Do you have Aadhar No"
            />
          </Grid>
          }
          {isAadharAvailable ? (
            <>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomeTextField
                  label="Aadhar No"
                  required
                  error={aadharNumberState}
                  value={aadharNumber || ""}
                  setState={setAadharNumber}
                  setError={setAadharNumberState}
                  id="aadhar_number"
                  visiblityIcon={!editable}
                  loanAccountNumber={loanAccountNumber}
                  viewType={"Aadhar Card"}
                  lastFourDigits={Number(aadharNumber) % 10000}
                  disabled={true}
                  validationState={aadharValidationAttempted}
                  validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
                />
              </Grid>
              {aadharDetails?.adhaarNumber && (
                <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                  <CustomeTextField
                    label="Masked Aadhar No"
                    required
                    value={aadharDetails?.adhaarNumber || ""}
                    disabled={true}
                    id="masked_aadhar_number"
                  />
                </Grid>
              )}
            </>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                <CustomeSelectNew
                  label="Document Name*"
                  error={documentNameState}
                  value={documentName}
                  setState={setDocumentName}
                  data={documentNameList}
                  setError={setDocumentNameState}
                  disabled={true}
                  type="displayName"
                  id="document_name"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
                <CustomeTextField
                  label="Document No"
                  required
                  error={documentNumberState}
                  value={documentNumber || ""}
                  setState={setDocumentNumber}
                  setError={setDocumentNumberState}
                  disabled={true}
                  id="document_number"
                  visiblityIcon={!editable && documentName === "AADHAR_CARD"}
                  loanAccountNumber={loanAccountNumber}
                  viewType={documentName}
                  lastFourDigits={Number(documentNumber) % 10000}
                  validationState={aadharValidationAttempted}
                  validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
                />
              </Grid>
              {(documentName === "PASSPORT" || documentName === "DRIVING_LICENSE") && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <InputLabel
                className={classes.label}
                style={{ textAlign: "left"}}
              >
               Document Expiry*
              </InputLabel>
              <CustomeDateCalender
                error={documentExpiryState}
                handleDateChange={handleDocumentExpiry}
                selectedDate={documentExpiry ? documentExpiry : null}
                id="document_expiry"
                inputProps={{
                  disabled: isAadharAvailable ? true : !editable || documentDisbale ,
                }}
              />
         </Grid>}
            </>
          )}
             {showPreFixName && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Applicant Pre Name*"
              id="pre_name"
              value={prefixName || PreFixNameList[0]}
              setState={handlePreFixName}
              data={PreFixNameList}
              disabled={!editable}
              setError={setPreFixNameState}
              error={prefixNameState}
            /> 
          </Grid>}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Applicant Name"
              required
              error={aadharApplicantNameState}
              value={aadharApplicantName || panApplicantName || ""}
              setState={setAadharApplicantName}
              disabled={(panValidate && !enabledFieldsForApplciantPage) || (enabledFieldsForApplciantPage && !editable)}
              setError={setAadharApplicantNameState}
              id="applicant_name"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Father Name"
              required
              error={aadharFatherNameState}
              value={aadharFatherName || ""}
              setState={setAadharFatherName}
              setError={setAadharFatherNameState}
              disabled={true}
              id="father_name"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Mother Name"
             required
             id="mother_name"
             error={motherNameErrorState}
             value={motherName || ""}
             setState={setMotherName} 
             setError={setMotherNameErrorState}
            //  disabled={true}
            disabled= {!editable}
             />
         </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <InputLabel className={classes.label} style={{ textAlign: "left" }}>
              Date Of Birth(DD/MM/YYYY)*
            </InputLabel>
            <CustomeDateCalender
              handleDateChange={handleDateChange}
              inputProps={{
                minDate: setyear(maxAgeForDateOfBirth),
                maxDate: setyear(minAgeForDateOfBirth),
                disabled: (panValidate && !enabledFieldsForApplciantPage) || (enabledFieldsForApplciantPage && !editable),
              }}
              selectedDate={dateOfBirth ? dateOfBirth : null}
              id="date_of_birth"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Marital Status*"
              error={maritalStatusState}
              value={maritalStatus}
              id="document_name"
              setState={setMateritalStatus}
              data={maritalStatusList}
              setError={setmaritalStatusState}
              type="name"
            disabled= {!editable}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Flat No./House No./Plot No./Building Name"
              required
              error={houseNumberState}
              value={houseNumber || ""}
              setState={setHouseNumber}
              setError={setHouseNumberState}
              disabled={true}
              id="house_number"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Street"
              required
              error={streetState}
              value={street || ""}
              setState={setStreet}
              setError={setStreetState}
              disabled={true}
              id="street"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Locality"
              required
              error={localityState}
              value={locality || ""}
              setState={setLocality}
              setError={setLocalityState}
              disabled={true}
              id="locality"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="PostOffice"
              required
              type="alphabets"
              error={postOfficeState}
              value={postOffice || ""}
              setState={setPostOffice}
              setError={setPostOfficeState}
              disabled={true}
              id="post_office"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Village/Town/City"
              required
              type="alphabets"
              error={villageTownCityState}
              value={villageTownCity || ""}
              setState={setVillageTownCity}
              setError={setVillageTownCityState}
              disabled={true}
              id="village_town"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="State"
                required
                type="alphabets"
                error={stateNameState}
                value={stateName || ""}
                setState={setStateName}
                setError={setStateNameState}
                disabled={true}
                id="state"
              />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="District"
              required
              type="alphabets"
              error={districtState}
              value={district || ""}
              setState={setDistrict}
              setError={setDistrictState}
              disabled={true}
              id="district"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Pincode"
              required
              type="digits"
              error={pincodeState}
              value={pincode || ""}
              setState={setPincode}
              disabled={true}
              setError={setPincodeState}
              id="pincode"
              maxLength="6"
            />
          </Grid>
          {showEmailOnApplicantFlag && <Grid
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ position: "relative" }}
          >
            <CustomeTextField
              label="Email"
              //  required
              error={emailState}
              value={email?.toLowerCase() || ""}
              setState={emaildataVerify}
              type="email"
              setError={setEmailState}
              disabled={true}
              id="email"
              validationState={emailValidationAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
            />
          </Grid>}
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Alternate Mobile Number"
              value={mobileNumber}
              error={mobileNumberState}
              setError={setMobileNumberState}
              setState={handleChange}
              disabled={!editable}
              id="alternate_mobile_number"
              maxLength="10"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Gender*"
              id="gender"
              value={gender || GenderList[0]}
              setState={setGender}
              // type="list"
              data={GenderList}
              disabled={!editable}

            /> 
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Name of Spouse"
             required
             id="spouse_name"
             error={spouseNameState}
             value={maritalStatus === "Single" ? "" : spouseName}
             setState={setSpouseName} 
             setError={setSpouseNameState}
             disabled= {maritalStatus === "Single" || !editable}
            //  disabled= {true}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Number of Member"
             required
             id="number_member"
             error={memeberCountError}
             value={memberCount || ""}
             setState={handleChange3} 
             setError={setMemberCountError}
             maxLength="3"
             disabled= {!editable}
            //  disabled= {true}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Annual Income"
             required
             id="annual_income"
             error={annualIncomeState}
             value={annualIncome || ""}
             setState={handleChange4} 
             setError={setAnnualIncomeState}
             setBlur={setAnnualIcomeBlur}
            //  disabled= {true}
            disabled= {!editable}
             />
         </Grid>
           <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Occupation Type*"
              id="occupation_type"
              value={occupationTypes || OccupationList[0]}
              setState={setoccupationTypes}
              // type="list"
              data={OccupationList}
              disabled={!editable}
            />
          </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Purpose Of Loan*"
              id="purpose_of_loan"
              value={purposeOfLoan || PurposeOfLoan[0]}
              // type="list"
              setState={setPurposeOfLoan}
              data={PurposeOfLoan}
              disabled={!editable}
            />
          </Grid>
        {showCustomerType && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                  <CustomeSelectNew
                    label="Customer Type*"
                    id="customer_type"
                    value={customerType || customerTypeData[0]?.code}
                    type="name"
                    setState={setCustomerType}
                    data={customerTypeData}
                    disabled={loanType === APPLICATION_TYPE_RE_PLEDGE ? !editable : true}
                  />
            </Grid>}
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="GST Number"
              value={gstNumber || ""}
              setState={setGstNumber}
               disabled={!editable}
              id="gst_number"
              type="gst"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            
          {!editable  ? (
          <CustomeTextField
          label={gstNumber ? "GST State*" : "GST State"}
          required={!!gstNumber}
          id="gst_state"
          value={gstStateName?.length > 0 ? gstStateName?.[0]?.name : ""}
          disabled={!editable}
          />
           ):(
            <CustomeSelectNew
            label={gstNumber ? "GST State*" : "GST State"}
            value={gst ? gst : ""}
            setState={setGst}
            data={stateList}
            type="type"
            id="gst_state"
            disabled={!editable}
            />
            )}
          </Grid>
          <Grid
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ position: "relative" }}
          >
            <CustomeTextField
              label="PAN No."
              required
              error={panApplicantNumberState}
              id="pan_number"
              value={panApplicantNumber?.toUpperCase()}
              setState={setPanApplicantNumber}
              setError={setPanApplicantNumberState}
              type="notCapital"
              maxLength="10"
              disabled={panNumberDisabled}
              validationState={panValidationAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
              // disabled={!editable || panDisable || panNumberDisable}
            />
            {editable === true && (
              <Button
                style={{
                  height: "40px",
                  width: "75px",
                  position: "absolute",
                  right: 0,
                  top: 0,
                  margin: 0,
                }}
                size="small"
                disabled={
                  (!enabledReKycForDocumentVerification && panVerified) ||
                  panApplicantNumber === "" ||
                  typeof panApplicantNumber === "undefined" ||
                  panApplicantNumber === null || aadharApplicantName === ""
                  || dateOfBirth === null || dateOfBirth === "NAN" || panApplicantNumber?.length < 10 || typeof dateOfBirth === "undefined"
                }
                onClick={() => GetProfileData('clickable')}
                className={classes.nextButton1}
              >
                verify
              </Button>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Applicant Name"
              required
              id="applicant_name"
              value={panApplicantName}
              setState={setPanApplicantName}
              disabled={(panVerifiedName && !enabledFieldsForApplciantPage )|| (enabledFieldsForApplciantPage && !editable) }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
                        <input
                          style={{ marginTop: 2, width:'30px', height:'30px' }}
                          type="checkbox"
                          // className={classTable.checkboxInput}
                          // checked={groupDetails[i].packetSealed}
                          disabled={!editable}
                          value= {digilance}
                          name="Profiling"
                          onChange={(e) => checkedDueDigilance(e)}
                          checked={digilance}
                        />
                     Profiling</label>
                      </Grid>
                      {digilance && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            {status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie ? <CustomeSelectNew
              label="Profiling*"
              id="digilance"
              value={digilanceState}
              setState={setDigilanceState}
              error={dueDigilance}
              setError={setDueDigilance}
              type="name"
              data={digilanceData}
              disabled={!editable}
            /> : 
            <CustomeTextField
            label="Profiling"
              id="digilance"
              required
            value={digilanceState}
            disabled
            />
            }
          </Grid>}
          <Grid item xs={12} sm={12} md={12} className={classes.addressContainer}>
            <Grid item xs={12} sm={7} md={6}>
              <h2 className={classes.header}>Correspondence Address</h2>
            </Grid>
            <Grid
              item
              xs={12}
              sm={5}
              md={6}
              className={classes.inputFieldContainer}
              style={{ marginTop: "15px", marginLeft: "0px" }}
            >
              {" "}
              <label>
                <input
                  type="checkbox"
                  value={sameAddress}
                  checked={sameAddress ? true : false}
                  onChange={(e) => checkedAddress(e)}
                  disabled={true}
                />
                same as permanent address
              </label>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <CorrespondenceAddress
            sameAddress={sameAddress}
            houseCorrNumberState={houseCorrNumberState}
            streetCorrState={streetCorrState}
            localityCorrState={localityCorrState}
            postOfficeCorrState={postOfficeCorrState}
            villageTownCityCorrState={villageTownCityCorrState}
            districtCorrState={districtCorrState}
            pincodeCorrState={pincodeCorrState}
            stateNameCorrState={stateNameCorrState}
            setHouseCorrNumberState={setHouseCorrNumberState}
            setDistrictCorrState={setDistrictCorrState}
            setVillageTownCityCorrState={setVillageTownCityCorrState}
            setStateNameCorrState={setStateNameCorrState}
            setPostOfficeCorrState={setPostOfficeCorrState}
            setLocalityCorrState={setLocalityCorrState}
            setStreetCorrState={setStreetCorrState}
            setPincodeCorrState={setPincodeCorrState}
            houseNumber={houseNumber}
            editable={loanType === APPLICATION_TYPE_RE_PLEDGE ? editable : false}
            street={street}
            locality={locality}
            postOffice={postOffice}
            villageTownCity={villageTownCity}
            stateName={stateName}
            stateList={stateList}
            district={district}
            pincode={pincode}
            classes={classes}
            coresHouseNumber={coresHouseNumber}
            setCoresHouseNumber={setCoresHouseNumber}
            coresLocality={coresLocality}
            setCoresLocality={setCoresLocality}
            coresStreet={coresStreet}
            setCoresStreet={setCoresStreet}
            coresPostOffice={coresPostOffice}
            setCoresPostOffice={setCoresPostOffice}
            coresVillage={coresVillage}
            setCoresVillage={setCoresVillage}
            coresDistrict={coresDistrict}
            setCoresDistrict={setCoresDistrict}
            coresPinCode={coresPinCode}
            setCoresPinCode={handleCorspinCode}
            coresState={coresState}
            setCoresState={setCoresState}
            disabledScreen={loanType === APPLICATION_TYPE_RE_PLEDGE ? false : true}
          />

          {status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie ? (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop: "5%",
                }}
              >
                {!firstTab && <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecancelapplicant()}
                >
                  Back
                </Button>
                }
                <Button
                  className={classes.nextButton}
                  size="small"
                  disbaled={callInProgress || riskPresent}
                  onClick={(event) => handlecreateapplicantSubmit(event)}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop: "5%",
                }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  disabled={callInProgress}
                  onClick={() => back()}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress || disableNext}
                  onClick={() => handlenext()}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          )}
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
         {confirmationModal && (
            <ConfirmationModal
              confirmationModal={confirmationModal}
              confirmationModalHeader={confirmationModalHeader}
              confirmationModalMsg={confirmationModalMsg}
              handleNegativeButton={handleNegativeResponse}
              handlePositiveButton={handlePositiveResponse}
              classes={classes}
            />
          )}
      </GridContainer>
    </div>
  );
};

ApplicantPostAndRePledge.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default withStyles(styles)(ApplicantPostAndRePledge);
